<template>

<div elevation="3" :disabled="disable"  :class="{ pasifCard: disable }">
               <div v-if="disable"  style="background: white;"><span style="color: red;">Bu öğe pasif olduğundan başvuru ekranında görüntülenmeyecektir. </span></div>
   <p class="ma-0">
            <strong style="color: black;" v-html="label"> </strong> <strong v-if="required" style="color: red;margin:0px 5px;">*</strong> 
         </p> 
       
            <v-select :items="getStoreItems" item-text="name" item-value="id" persistent-hint :hint="hint"      outlined
                :rules="getComponentName" clearable v-model="value" @change="changeEvent($event)" :multiple="multi">
                <!-- <template v-slot:label>
                    <p>
                        <strong v-if="required" style="color: red;margin:0px 5px;">*</strong> <strong v-html="label">
                        </strong>
                    </p>
                </template> -->
                   <template v-slot:append-outer>
    <slot name="edit"></slot>
   </template>
            </v-select>
</div>

    <!-- <v-card elevation="3" :disabled="disable"  :class="{ pasifCard: disable }">
        <v-card-text>

        </v-card-text>
    </v-card> -->

</template>
<script>
import { selectSF } from '@/plugins/FieldDataFormat.js'
import { rules, CustomFunc } from '@/plugins/custom.js'
export default {
    data() {
        return {
            id: "",
            value: null,
            label: "",
            required: false,
            color: null,
            disable: false,
            hint: "",
            items: [],
            store: [],
            rules: [v => !!v || 'Name is required'],
            placeholder: "Yanıtınız",
            trigger: false,
            triggerId: "",
            multi: false
        }
    },
    props: {
        ayar: {
            // default: '{"title":"","description":""}',
            default() {
                return selectSF;
            },
            type: Object
        },


    },
    methods: {
        changeEvent(e) {
            this.$emit('input', e);
           // console.log("changeEvent", e);
            if (this.trigger) {
                let values = this.store.
                    filter(m => {
                        let index = m.name.indexOf("::");
                        let value = m.name.substring(0, index);
                        return !value.localeCompare(e)
                    }).
                    map(item => {
                        let index = item.name.indexOf("::");
                        if (index > -1) {
                            let value = item.name.substring(index + 2, item.name.lenght);
                            return { id: value, name: value };
                        }
                        return item;
                    })
                this.$emit('triggerEvent', { id: this.triggerId, values })
            }
            else {
                return e;
            }


        },
        dataBind(json) {
            //console.log("Vtext Json VSELECT", json);
            // let ayarJson = JSON.parse(jsonStr);
            this.title = json.title;
            this.description = json.description;
            this.rules = json.rules;
            this.hint = json.hint;
            this.label = json.label;
            this.required = json.required;
            this.items = json.items;
            this.store = json.store;
            this.trigger = json.trigger;
            this.triggerId = json.triggerId;
            this.id = json.id;
            this.multi = json.multi;
            this.disable=json.disable;
            this.value = json.multi ? json.value.split(',') : json.value;

        }
    },
    computed: {
        getComponentName() {
            return this.rules.map(m => rules[m]);

        },
        // a computed getter
        getAyar: function () {
            // `this` points to the vm instance
            return this.ayar;
        },
        getStoreItems: function () {
            let itemListesi = [];

            if (!this.trigger) {
                //console.log("getStoreItems2", this.store);
                if (this.store) {
                            this.store.forEach(m => {
               
                   itemListesi.push(m);

                })
                }
        



            }
            else {

                itemListesi = this.store.map(item => {
                    let index = item.name.indexOf("::");
                    if (index > -1) {
                        let value = item.name.substring(0, index);
                        return { id: value, name: value };
                    }
                    return item;
                })
               // itemListesi = [...new Set(itemListesi.map(item => item.name))];
               // itemListesi = [...new Set(itemListesi.map(item => {  return { id: item.name, name: item.name }; }))];
                // this.store.forEach(m => {
                //     let parentData = m.name.split("::");
                //     itemListesi.push(({ id: parentData[1], name: parentData[1], parent: parentData[0] }));

                // })
            }
           
            return itemListesi;
        },
        // iç kullanım için modelValue (opsiyonel)
        model: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val); // v-model'e değer gönder
            }
        }

    },
    created() {
        this.dataBind(this.ayar);
           if (this.trigger) {
             this.changeEvent(this.value)
           }
        //  this.value=  this.ayar.value.length>0 ? this.ayar.value.split(',') : [];
    },
    watch: {
        ayar: {
            immediate: true,
            handler(newVal, oldVal) {
                // console.log("handler:",newVal);
                // if  (newVal.required){
                // newVal.rules.push(value => !!value || 'Bu alana boş bırakılamaz.')
                // }

                this.dataBind(newVal);
                //this.slots.forEach(slot => {
                //    if (slot.availability > 10) slot.availability = 10;
                //});
            },
            deep: true
        }

    },

}
</script>
<style scoped>
.pasifCard{
  background-color: gray !important;
}
</style>